module.exports = __webpack_public_path__ + "static/media/faq-caseid.83616a41.svg";